import React from 'react';
export function FinalThoughts() {
  return <section className="border-b border-line bg-night py-20 sm:py-24" data-id="element-105" data-mp="2oo4wbem097ls">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-106" data-mp="2ex3mh1yt2x0z">
        <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-107" data-mp="2spjukh6kdl8r">
          Final thoughts
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl" data-id="element-108" data-mp="2onpxsjzhp1dv">
          Stop improvising. Start architecting.
        </h2>
        <div className="mt-8 space-y-5 text-base leading-relaxed text-white/60 sm:text-lg" data-id="element-109" data-mp="1vzkfs4ztlqhq">
          <p data-id="element-110" data-mp="29ytuf08docjl">
            You&rsquo;ve spent years learning the game. Your academy deserves a
            curriculum that matches the standard you coach to.
          </p>
          <p data-id="element-111" data-mp="2523gaig4vr0t">
            Your academy is either getting better, or it is getting left behind.
            Join the directors who now plan an entire season in a single
            evening.
          </p>
        </div>
        <p className="mt-8 border-l-2 border-acid pl-5 font-display text-2xl font-bold uppercase leading-tight tracking-tight text-white sm:text-3xl" data-id="element-112" data-mp="1quej5kisnjl6">
          Stop the chaos. Start the system.
        </p>
      </div>
    </section>;
}